module.exports = __webpack_public_path__ + "static/media/drapes.e9b27542.png";